import React from "react";
import { Media } from "reactstrap";

interface ImageTypes {
  body?: boolean;
  bottom?: boolean;
  heading?: boolean;
  left?: boolean;
  list?: boolean;
  middle?: boolean;
  object?: boolean;
  right?: boolean;
  tag?: React.ElementType;
  top?: boolean;
  src?: string;
  href?: string;
  alt?: string;
  className?:string;
  width?:string;
  height?:string;
  style?:{ width: string; };
  id?:string
}

const Image = (props: ImageTypes) => <Media {...props} />;

export default Image;
